import { useEffect, useMemo, useState } from "react";
import img1 from "../../res/bsce-se.jpg";
import img2 from "../../res/bsce-te.jpg";
import img3 from "../../res/bsce-cem.webp";
import logo from "../../res/logo.png";
import { Link } from "react-router-dom";

function Feature(props) {
  const features2 = props.features;
  const onFeatureChange = props.onFeatureChange;

  const [features, setFeatures] = useState([
    {
      title: "Loading",
      cover: logo,
      body: "",
      url: "#",
    },
    { title: "Title 2", cover: img2, body: "", url: "#" },
    { title: "Title 3", cover: img3, body: "", url: "#" },
  ]);
  const [activeFeat, setActiveFeat] = useState(0);

  const newFeatures = () => {
    const newFeat = [];
    for (let i = 0; i < 3; i++) {
      if (features2[i] === undefined) {
      } else {
        let newItem = {
          title: features2[i].title,
          cover: features2[i].imgurl,
          url: features2[i].url,
          body: features2[i].body,
        };
        newFeat.push(newItem);
      }
    }
    if (newFeat.length) {
      setFeatures(newFeat);
      setActiveFeat(0);
    }
  };
  useEffect(() => {
    newFeatures();
  }, [features2]);

  const changeFeat = () => {
    setActiveFeat((prev) => (prev + 1) % features.length);
  };

  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (seconds === 5) {
      changeFeat();
      setSeconds(0);
    }
  }, [seconds]);

  const activeFeature = useMemo(() => {
    if (!features.length) return { title: "Loading", cover: logo, url: "#" };
    return features[activeFeat] || features[0];
  }, [activeFeat, features]);

  useEffect(() => {
    if (onFeatureChange && activeFeature.title) {
      onFeatureChange(activeFeature.title);
    }
  }, [activeFeature.title, onFeatureChange]);

  return (
    <div className="group relative h-full w-full overflow-hidden shadow-lg">
      <img
        src={activeFeature.cover}
        className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
        alt={activeFeature.title}
      />
      <div className="pointer-events-none absolute inset-x-0 bottom-0">
        <div className="bg-gradient-to-t from-black/70 via-black/40 to-transparent pt-8 pb-24 px-4 flex flex-col justify-center items-center w-full min-w-0">
          <Link
            className="pointer-events-auto block w-full max-w-full min-w-0 truncate text-center text-xl sm:text-2xl font-bold text-white drop-shadow-lg [text-shadow:_-2px_4px_5px_rgb(0_0_0_/_40%)] hover:underline transition-opacity duration-200 max-w-screen-xl"
            to={activeFeature.url || "#"}
            title={activeFeature.title}
          >
            {activeFeature.title}
          </Link>
          {activeFeature.body && (
            <p className="mt-2 text-center text-sm text-white/80 truncate px-2 max-w-screen-xl">
              {activeFeature.body}
            </p>
          )}
          
        </div>
      </div>
    </div>
  );
}

export default Feature;
